//Lib 
import { mapState } from "vuex";

// Api
import api from '@/api/baseApi';

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE } from "@/constant/extraService";
import { SERVICE_TYPE } from "@/constant/rental";

// Function 
const queryString = require('query-string');

export default {

  extends: baseExtraService,

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },

  data() {

    return {
      packageId: null,
      note: null,
      packageList: []
    };
  },

  mounted() {
    this.servicePackageView();
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    //#region Close this pop-up
    closeThisPopup() {
      this.closePopup(POPUP_ID.EXTRA_SERVICE_NVLINK);
    },
    //#endregion

    //#region Service package
    servicePackageView() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      let data = {
        serviceType: SERVICE_TYPE.GPUHUB
      }
      setTimeout(() => {
        api.baseRequest(SETTINGS_RENTAL_API.SERVICE_PACKAGE_VIEW, null, `?${queryString.stringify(data)}`)
          .then((res) => {
            let responseData = res.data;
            let packageList = responseData.filter(x => x.nvlink);
            if(packageList && packageList !== null && packageList.length > 0){
              this.packageId = packageList[0].id
            }
            this.packageList = packageList;
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.servicePackageList);
          })
          .catch(error => {
            this.processCatchApiRequest(error, "Request failed ...")
          });
      }, this.smoothTimeOut);
    },
    //#endregion

    //#region Expand image threshold send request
    send() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          type: EXTRA_SERVICE_TYPE.NVLINK,
          packageId: this.packageId,
          note: this.note,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        this.createRequest(
          data,
          () => { this.closeThisPopup() }
        )
      }, this.smoothTimeOut);
    },
    //#endregion 
  },
}